// ─────────────────────────────────────────────────────────────────────────────
// tokens/colors.ts
//
// Fonte única de verdade para todas as cores do admin.
// Nunca use hexadecimal diretamente no código — importe daqui.
// ─────────────────────────────────────────────────────────────────────────────

// ── Brand ────────────────────────────────────────────────────────────────────
export const brand      = '#6f2176';
export const brandHover = '#5a1a60';
export const brandLight = '#f5edf6';

// ── Info (ações secundárias, links, seleções) ─────────────────────────────────
export const info      = '#185FA5';
export const infoLight = '#E6F1FB';
export const infoText  = '#0C447C';

// ── Superfícies ───────────────────────────────────────────────────────────────
export const surface = '#ffffff'; // cards, inputs, modais
export const canvas  = '#F9F8F5'; // barras, painéis, fundos de seção
export const page    = '#f8f6f9'; // fundo da página

// ── Texto ────────────────────────────────────────────────────────────────────
export const textPrimary   = '#1A1A18';
export const textSecondary = '#5C5C58';
export const textTertiary  = '#9C9C96';
export const textDisabled  = '#C4C3BE';

// ── Bordas ────────────────────────────────────────────────────────────────────
export const borderSubtle  = '#E5E4DE'; // separadores, cards em repouso
export const borderDefault = '#D3D1C7'; // inputs, botões outline
export const borderStrong  = '#B4B2A9'; // ênfase

// ── Semânticas ────────────────────────────────────────────────────────────────
export const success      = '#0F6E56';
export const successLight = '#E1F5EE';
export const successText  = '#085041';

export const warning      = '#BA7517';
export const warningLight = '#FAEEDA';
export const warningText  = '#633806';

export const danger      = '#A32D2D';
export const dangerLight = '#FCEBEB';
export const dangerText  = '#791F1F';

// ── Objeto agrupado (para uso em styled-components ou objetos de tema) ─────────
export const colors = {
  brand,
  brandHover,
  brandLight,
  info,
  infoLight,
  infoText,
  surface,
  canvas,
  page,
  text: {
    primary:   textPrimary,
    secondary: textSecondary,
    tertiary:  textTertiary,
    disabled:  textDisabled,
  },
  border: {
    subtle:  borderSubtle,
    default: borderDefault,
    strong:  borderStrong,
  },
  success,
  successLight,
  successText,
  warning,
  warningLight,
  warningText,
  danger,
  dangerLight,
  dangerText,
} as const;
